import React from 'react';
import { Content, Controls, Header, InfoGroup, ProductInfo, Wrapper } from './card-approval-manager-request.styles';
import { CardApprovalManagerRequestProps } from './types';
import { Typography } from '@shared/ui/typography/typography';
import { userName } from '@shared/lib/utils/user-name/user-name';
import dayjs from 'dayjs';
import { Tag } from '@shared/ui/tag/tag';
import { useCurrentOrganizationPreviewSharedQuery } from '@entities/organization/libs/hooks/use-current-organization-preview-shared-query/use-current-organization-preview-shared-query';
import { useCurrentUserSelector } from '@entities/current-user/model/selectors';
import { MANAGER_REQUEST_STATUS_MAP } from '../../config/ui-constants';
import { EntityRelatedUser } from '@shared/ui/entity-related-user/entity-related-user';
import { productPrice } from '@shared/lib/utils/product-price/product-price';

export const CardApprovalManagerRequest: React.FC<CardApprovalManagerRequestProps> = ({
    request,
    children,
    onClick,
}) => {
    const user = useCurrentUserSelector();

    const [, currentOrganization] = useCurrentOrganizationPreviewSharedQuery(user?.company?.id || 0);

    const manager = currentOrganization.data?.manager;
    const managerName = userName({
        firstName: manager?.firstName,
        lastName: manager?.lastName,
        middleName: manager?.middleName,
    });

    return (
        <Wrapper onClick={onClick}>
            <Header>
                <ProductInfo>
                    <Typography size='subtitle2' color='neutral_90'>
                        {request.product?.name}
                    </Typography>
                </ProductInfo>
                <Controls>{children}</Controls>
            </Header>
            <Content>
                <InfoGroup $maxWidth={198}>
                    <Typography size='body2_long' color='neutral_50'>
                        Дата создания запроса
                    </Typography>
                    <Typography size='body2_long'>{dayjs(request.createdAt).format('DD.MM.YY')}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={198}>
                    <Typography size='body2_long' color='neutral_50'>
                        Количество продукта
                    </Typography>
                    <Typography size='body2_long'>{request.quantity}</Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={140}>
                    <Typography size='body2_long' color='neutral_50'>
                        Стоимость
                    </Typography>
                    <Typography size='body2_long'>
                        {productPrice({
                            price: (request.quantity * parseInt(request.product.price)).toFixed(2),
                            withoutPrice: request.product.isPriceUndefined,
                        })}
                    </Typography>
                </InfoGroup>
                <InfoGroup $maxWidth={220}>
                    <Typography size='body2_long' color='neutral_50'>
                        Инициатор
                    </Typography>
                    <EntityRelatedUser user={request.user} nameType='short' />
                </InfoGroup>
                <InfoGroup $maxWidth={164}>
                    <Typography size='body2_long' color='neutral_50'>
                        Статус
                    </Typography>
                    <Tag
                        variant={MANAGER_REQUEST_STATUS_MAP[request.status]?.variant}
                        declineMessage={
                            {
                                managerAvatarUrl: manager?.photoUrl || '',
                                managerName: managerName.full,
                                message: request.comment || '',
                            } || undefined
                        }>
                        {MANAGER_REQUEST_STATUS_MAP[request.status]?.children}
                    </Tag>
                </InfoGroup>
            </Content>
        </Wrapper>
    );
};
